import * as React from 'react';
import { ReactNode, useContext, useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { AuthContext } from '../../Auth/components/AuthProvider';
import { Loading } from '../system/Loading';

interface RedirectComputedPathProps {
  computePathFunc: () => string;
}

export const RedirectComputedPath: React.FC<RedirectComputedPathProps> = (props): ReactNode => {
  const [searchParams] = useSearchParams();
  const { actions } = useContext(AuthContext);
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (searchParams.has('code')) {
      const code: string = searchParams.get('code');
      const authState: string = searchParams.get('state');
      actions
        .getTokenWithCode(code, authState)
        .then((): void => {
          setLoading(false);
        })
        .catch((ex: any): void => {
          console.warn(ex);
          setLoading(false);
        });
    }
  }, []);

  if (loading) {
    return <Loading />;
  } else {
    return <Navigate to={props.computePathFunc()} />;
  }
};
